// Case Buddy domain module generated from CaseBuddyCore.js.
// Spreadsheet-shaped rows remain the source of truth.
import { normalizeCell } from './CaseBuddyShared.js';

export const CASE_BRIDGE_SERVICE_DEFINITIONS = Object.freeze([
  { canonicalName: 'BKBridge', aliases: ['BKBridge', 'BK Bridge'], explorerLabel: 'Open BKBridge Explorer', explorerUrl: '', searchHint: 'Search the bridge service or its explorer for the parent transaction hash.' },
  { canonicalName: 'OKX Router Web3', aliases: ['OKX Router Web 3', 'OKX Router Web3', 'OKX Web3 Router', 'OKX Web 3 Router', 'OKX Dex Router', 'OKX DEX Router'], explorerLabel: 'Open OKX Web3 Explorer', explorerUrl: '', searchHint: 'Use the OKX Web3 / DEX router trace first; do not treat generic OKX attribution as a bridge by itself.' },
  { canonicalName: 'Rango', aliases: ['Rango', 'Rango Exchange', 'Rango Explorer', 'Rango (DEX)', 'Rango DEX'], explorerLabel: 'Open Rango Explorer', explorerUrl: 'https://explorer.rango.exchange/', searchHint: 'Search Rango Explorer by the selected parent transaction hash and look for the destination-chain receive transaction.' },
  { canonicalName: 'Bridgers', aliases: ['Bridgers', 'Bridgers.xyz', 'Bridgers Explorer'], explorerLabel: 'Open Bridgers Explorer', explorerUrl: 'https://explorer.bridgers.xyz/#/', searchHint: 'Search Bridgers by the selected parent transaction hash and look for the destination-chain receive transaction.' },
  { canonicalName: 'Allchainbridge', aliases: ['Allchainbridge', 'Allchain bridge', 'Allchain Bridge', 'All Chain Bridge', 'Allchainbridge.com'], explorerLabel: 'Open Allchainbridge Explorer', explorerUrl: 'https://explorer.allchainbridge.com/', searchHint: 'Search Allchainbridge by the selected parent transaction hash and confirm the destination network before applying the Bridge graft.' },
  { canonicalName: 'CrossChainX', aliases: ['CrossChainX', 'Cross Chain X', 'CrossChain X'], explorerLabel: 'Open Bridgers / CrossChainX Explorer', explorerUrl: 'https://explorer.bridgers.xyz/#/', searchHint: 'CrossChainX may resolve through Bridgers-style explorer data. Search by the selected parent transaction hash.' },
  { canonicalName: 'Teleport', aliases: ['Teleport', 'Teleswap', 'TeleSwap'], explorerLabel: 'Open Teleport / Teleswap Explorer', explorerUrl: '', searchHint: 'Search the Teleport/Teleswap bridge explorer or related scan by parent transaction hash.' },
  { canonicalName: 'TransitSwap', aliases: ['TransitSwap', 'Transit Swap', 'TransitFinance', 'Transit Finance'], explorerLabel: 'Open TransitSwap Explorer', explorerUrl: '', searchHint: 'Search TransitSwap bridge details by parent transaction hash.' },
  { canonicalName: 'SWFT Blockchain', aliases: ['SWFT Blockchain', 'SWFT', 'SWFT Bridge', 'SWFT Swap'], explorerLabel: 'Open SWFT Explorer', explorerUrl: '', searchHint: 'Search SWFT bridge details by parent transaction hash.' },
  { canonicalName: 'Wormhole', aliases: ['Wormhole', 'Wormholescan', 'Wormhole Scan', 'Portal Bridge'], explorerLabel: 'Open Wormholescan', explorerUrl: 'https://wormholescan.io/', searchHint: 'Search Wormholescan by the selected parent transaction hash and verify the destination-chain receive hash.' },
  { canonicalName: 'Near-Intents', aliases: ['Near-Intents', 'Near Intents', 'NEAR Intents', 'Near Intents Explorer'], explorerLabel: 'Open Near-Intents Explorer', explorerUrl: 'https://explorer.near-intents.org/', searchHint: 'Search Near Intents by the selected parent transaction hash and identify the post-bridge receive transaction.' },
  { canonicalName: 'Chainflip', aliases: ['Chainflip', 'Chainflip Scan', 'Chainflip (Bridge)'], explorerLabel: 'Open Chainflip Scan', explorerUrl: 'https://scan.chainflip.io/', searchHint: 'Search Chainflip Scan by the selected parent transaction hash and confirm the destination asset/network.' },
  { canonicalName: 'Butterswap', aliases: ['Butterswap', 'Butter Swap', 'Butterswap Explorer'], explorerLabel: 'Open Butterswap Explorer', explorerUrl: 'https://explorer.butterswap.io/', searchHint: 'Search Butterswap Explorer by the selected parent transaction hash and copy the destination transaction into raw-data gathering.' },
  { canonicalName: 'Allbridge', aliases: ['Allbridge', 'All Bridge', 'Allbridge Core'], explorerLabel: 'Open Allbridge Explorer', explorerUrl: 'https://core.allbridge.io/explorer/', searchHint: 'Search Allbridge Core by the selected parent transaction hash and confirm destination network/token details.' },
  { canonicalName: 'Hifiswap', aliases: ['Hifiswap', 'Hifi Swap', 'HiFiSwap'], explorerLabel: 'Open Hifiswap Search', explorerUrl: 'https://hifiswap.io/search', searchHint: 'Search Hifiswap by the selected parent transaction hash and use the destination transaction as the post-bridge raw-data root.' }
]);

export function normalizeBridgeRegistryValue(value) {
  return value == null ? '' : String(value).trim();
}

export function normalizeBridgeTextForMatching(value) {
  let safe = normalizeBridgeRegistryValue(value).toLowerCase();
  if (!safe) return '';
  safe = safe.replace(/web\s*3/g, 'web3').replace(/web-3/g, 'web3');
  safe = safe.replace(/[\r\n\t]+/g, ' ');
  safe = safe.replace(/[^a-z0-9]+/g, ' ');
  return safe.replace(/\s+/g, ' ').trim();
}

export function bridgeContainsNormalizedTerm(normalizedText, normalizedAlias) {
  if (!normalizedText || !normalizedAlias) return false;
  const escaped = normalizedAlias.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return new RegExp(`(^|\\s)${escaped}($|\\s)`, 'i').test(normalizedText);
}

export function createCaseBridgeServiceMatch(overrides = {}) {
  return {
    isMatch: false,
    canonicalName: '',
    matchedAlias: '',
    explorerLabel: '',
    explorerUrl: '',
    searchHint: '',
    source: '',
    definition: null,
    ...overrides
  };
}

export function bridgeMatchFromDefinition(definition = {}, alias = '', source = '') {
  if (!definition || !definition.canonicalName) return createCaseBridgeServiceMatch();
  return createCaseBridgeServiceMatch({
    isMatch: true,
    canonicalName: definition.canonicalName,
    matchedAlias: normalizeBridgeRegistryValue(alias || definition.canonicalName),
    explorerLabel: normalizeBridgeRegistryValue(definition.explorerLabel),
    explorerUrl: normalizeBridgeRegistryValue(definition.explorerUrl),
    searchHint: normalizeBridgeRegistryValue(definition.searchHint),
    source: normalizeBridgeRegistryValue(source),
    definition
  });
}

export function findCaseBridgeServiceByCanonicalOrAlias(value) {
  const target = normalizeBridgeTextForMatching(value);
  if (!target) return createCaseBridgeServiceMatch();

  for (const definition of CASE_BRIDGE_SERVICE_DEFINITIONS) {
    if (normalizeBridgeTextForMatching(definition.canonicalName) === target) {
      return bridgeMatchFromDefinition(definition, definition.canonicalName, 'service-field');
    }

    for (const alias of definition.aliases || []) {
      if (normalizeBridgeTextForMatching(alias) === target) {
        return bridgeMatchFromDefinition(definition, alias, 'service-field');
      }
    }
  }

  return createCaseBridgeServiceMatch();
}

export function findBestCaseBridgeServiceMatch(text) {
  const normalizedText = normalizeBridgeTextForMatching(text);
  if (!normalizedText) return createCaseBridgeServiceMatch();

  let best = createCaseBridgeServiceMatch();
  let bestScore = -1;
  CASE_BRIDGE_SERVICE_DEFINITIONS.forEach((definition) => {
    (definition.aliases || []).forEach((alias) => {
      const normalizedAlias = normalizeBridgeTextForMatching(alias);
      if (!bridgeContainsNormalizedTerm(normalizedText, normalizedAlias)) return;
      if (normalizedAlias.length <= bestScore) return;
      bestScore = normalizedAlias.length;
      best = bridgeMatchFromDefinition(definition, alias, 'selected-row');
    });
  });

  return best;
}

export function normalizeCaseBridgeServiceNameForStorage(value) {
  const match = findCaseBridgeServiceByCanonicalOrAlias(value);
  return match?.canonicalName || normalizeBridgeRegistryValue(value);
}

export function serializeCaseBridgeServiceMatch(match = null) {
  if (!match?.isMatch) return null;
  return {
    isMatch: true,
    canonicalName: normalizeBridgeRegistryValue(match.canonicalName),
    matchedAlias: normalizeBridgeRegistryValue(match.matchedAlias),
    explorerLabel: normalizeBridgeRegistryValue(match.explorerLabel),
    explorerUrl: normalizeBridgeRegistryValue(match.explorerUrl),
    searchHint: normalizeBridgeRegistryValue(match.searchHint),
    source: normalizeBridgeRegistryValue(match.source)
  };
}

export function buildBridgeSearchTextFromPathOperationCandidate(candidate = {}) {
  if (!candidate) return '';
  return [
    candidate.systemNotes,
    candidate.analystNotes,
    candidate.attribution,
    candidate.continuesAs,
    candidate.pathLabel,
    candidate.hash,
    candidate.toAddress
  ].map(normalizeBridgeRegistryValue).filter(Boolean).join(' ');
}

export function buildBridgeSearchClipboardText(candidate = {}, match = null, destinationNetwork = '', destinationToken = '') {
  const activeMatch = match?.isMatch ? match : createCaseBridgeServiceMatch();
  const rows = [
    ['Bridge search field', 'Value'],
    ['Bridge service', normalizeBridgeRegistryValue(activeMatch.canonicalName || candidate?.attribution || 'Bridge service')],
    ['Matched alias', normalizeBridgeRegistryValue(activeMatch.matchedAlias)],
    ['Explorer label', normalizeBridgeRegistryValue(activeMatch.explorerLabel)],
    ['Explorer URL', normalizeBridgeRegistryValue(activeMatch.explorerUrl)],
    ['Parent transaction hash', normalizeBridgeRegistryValue(candidate?.hash)],
    ['Parent To Address', normalizeBridgeRegistryValue(candidate?.toAddress)],
    ['Funds followed', normalizeBridgeRegistryValue(candidate?.fundsFollowed)],
    ['Left bounds', normalizeBridgeRegistryValue(candidate?.leftBoundsNumeric || candidate?.leftBoundsDisplay)],
    ['Source network', normalizeBridgeRegistryValue(candidate?.chainName)],
    ['Destination network', normalizeBridgeRegistryValue(destinationNetwork)],
    ['Destination token', normalizeBridgeRegistryValue(destinationToken)],
    ['Hint', normalizeBridgeRegistryValue(activeMatch.searchHint) || 'Search by parent transaction hash and identify the post-bridge receive transaction.']
  ];

  return rows.map(row => row.map(cell => String(cell ?? '').replace(/\t/g, ' ').replace(/\r?\n/g, ' ')).join('\t')).join('\n');
}

export function buildBridgeNetworkPhrase(destinationNetwork = '') {
  const network = normalizeCell(destinationNetwork);
  if (!network) return '';
  return /\bnetwork\b/i.test(network) ? network : `${network} network`;
}

export function buildBridgeOutSystemNote(destinationNetwork = '', bridgeService = '') {
  const service = normalizeCell(bridgeService) || 'the bridge service';
  const networkPhrase = buildBridgeNetworkPhrase(destinationNetwork);
  return networkPhrase ? `The funds are bridged to the ${networkPhrase} using ${service}.` : `The funds are bridged using ${service}.`;
}

export function buildBridgeInSystemNote(destinationNetwork = '', bridgeService = '') {
  const service = normalizeCell(bridgeService) || 'the bridge service';
  const networkPhrase = buildBridgeNetworkPhrase(destinationNetwork);
  return networkPhrase ? `The funds are received on the ${networkPhrase} via ${service}.` : `The funds are received via ${service}.`;
}
